<template>
  <div>
    <RichText :text="text" class="mb-base max-w-2xl" />
    <FkStrapiCollection
      :collection="`${collection}`"
      :use-pagination="pagination"
      :use-filter-bar="filterBar"
      :sort="sortBy"
      :pagination="{
        page: pageNr,
        pageSize: pageSize ?? 12,
      }"
      :filters="filters"
      :class="{
        //If the collection is not 'blog'
        'grid lg:grid-cols-[300px_1fr] items-start gap-base':
          collection != 'blog' && !workAtView,
        // If the collection is 'Werken bij'
        'work-at': workAtView,
      }"
    >
      <template
        v-if="collection === 'vacancy' || collection === 'company'"
        #customItem
      >
        <BlockCallToAction :idx="0" />
      </template>
    </FkStrapiCollection>
  </div>
</template>

<script lang="ts" setup>
import type { BlockCollectionList } from "@flyingkiwi/nuxt-components";
import { useRoute, computed } from "#imports";
const { workAtView } = useWorkAtView();

const props = defineProps<BlockCollectionList>();
const route = useRoute();
const sortBy = computed(() => {
  // If the collection is 'vacancy' overrule sort by expiresAt:desc
  if (props.collection === "vacancy") {
    return "expiresAt:desc";
  }
  // If the block has a sortBy property, use that
  if (props.sortBy) {
    return props.sortBy;
  }
  // Default sort by createdAt:desc
  return "createdAt:desc";
});
const pageNr = computed(() => {
  const idx = `${route.query.p}`;
  const page = Number.parseInt(idx ?? "1");
  if (!Number.isInteger(page) && !Array.isArray(page)) {
    return 1;
  }
  return page;
});
const { collectionKey } = useInjectionKeys();
const pageCollection = inject(collectionKey);

const filters = computed(() => {
  if (pageCollection === props.collection && route.params.slug) {
    return {
      slug: {
        $ne: route.params.slug,
      },
    };
  }
  return {};
});

onMounted(() => {
  //Get previous route from window
  const previousRoute = window.history.state;
  if (
    String(previousRoute.current).startsWith("/vacatures") &&
    String(previousRoute.forward).includes("/vacatures/")
  ) {
    //Get everything after /vacatures/ from the previous route
    const previousRouteSlug = String(previousRoute.forward).split(
      "/vacatures/",
    )[1];
    //Scroll to Anchor 'anchor-'+previousRouteSlug
    setTimeout(() => {
      const anchorElement = document.getElementById(
        "anchor-" + previousRouteSlug,
      );
      if (anchorElement) {
        anchorElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 500);
  }
  if (
    String(previousRoute.current).startsWith("/bedrijven") &&
    String(previousRoute.forward).includes("/bedrijven/")
  ) {
    //Get everything after /vacatures/ from the previous route
    const previousRouteSlug = String(previousRoute.forward).split(
      "/bedrijven/",
    )[1];
    //Scroll to Anchor 'anchor-'+previousRouteSlug
    setTimeout(() => {
      const anchorElement = document.getElementById(
        "anchor-" + previousRouteSlug,
      );
      if (anchorElement) {
        anchorElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 500);
  }
});
</script>

<style lang="css" scoped>
:deep(.items) {
  @apply mt-0 grid grid-cols-1 gap-4;
}

:deep(.items)#items-vacancy > div:nth-child(n + 2):nth-child(-n + 4) {
  @apply -order-1;
}

:deep(.items)#items-vacancy > div:first-child > div {
  @apply !min-h-0 !py-12;
}

:deep(.items)#items-vacancy > div:first-child h2 {
  @apply text-xl;
}

:deep(.items)#items-company,
:deep(.items)#items-blog {
  @apply md:grid-cols-2 lg:grid-cols-3;
}

:deep(.pagination) {
  @apply lg:col-start-2;
}

:deep(.items)#items-company > a:nth-child(n + 2):nth-child(-n + 4) {
  @apply -order-1;
}

:deep(.items)#items-company > div:first-child {
  @apply lg:col-span-full;
}

/* Hide the job alert on the 'Werken bij' pagina */
.work-at :deep(.items)#items-company > div:first-child {
  @apply hidden;
}
</style>
